import React from "react";
import { createRoot } from "react-dom/client";

import "./styles/global.scss";
import "./styles/index.scss";

import App from "./App";
import ErrorBoundary from "./components/errorBoundary";
import MainError from "./components/errorBoundary/MainError";

import "./i18n";
import { Toaster } from "sonner";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root")!);

root.render(
  <ErrorBoundary fallback={(error: Error | undefined) => <MainError error={error} />}>
    <Toaster richColors />
    <App />
  </ErrorBoundary>
);
